import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import PickerLocale from "@bedrock/date-picker/es/locale/ja_JP";

function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;

  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;

      case 'week':
        mergedFormat = 'YYYY年-w週目';
        break;

      case 'month':
        mergedFormat = 'YYYY-MM';
        break;

      case 'quarter':
        mergedFormat = 'YYYY-[Q]Q';
        break;

      case 'year':
        mergedFormat = 'YYYY';
        break;

      default:
        mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  }

  return mergedFormat;
}

var messages = _objectSpread(_objectSpread({}, PickerLocale), {}, {
  timeSelectPlaceholder: '時刻を選択',
  dateSelectPlaceholder: '日付を選択',
  monthSelectPlaceholder: '月を選択',
  quarterSelectPlaceholder: '四半期を選択',
  yearSelectPlaceholder: '年を選択',
  rangeTimeSelectPlaceholder: ['開始時刻', '終了時刻'],
  rangeDateSelectPlaceholder: ['開始日', '終了日'],
  rangeMonthSelectPlaceholder: ['開始月', '終了月'],
  rangeQuarterSelectPlaceholder: ['開始四半期', '終了四半期'],
  rangeYearSelectPlaceholder: ['開始年', '終了年'],
  monthFormat: 'M月',
  shortWeekDays: ['日', '月', '火', '水', '木', '金', '土'],
  weekFormat: 'YYYY年/w週目',
  getDefaultFormat: getDefaultFormat
});

export default messages;